import React from "react";
import { ReactComponent as Error404 } from "../../img/404.svg";
import { StyledErrorTitle, StyledErrorP } from "./style/utils.style.js";

const ErrorPage = () => {
  return (
    <div>
      <StyledErrorTitle>Oh, dear</StyledErrorTitle>
      <StyledErrorP>Something went wrong, we’re working on fixing it. </StyledErrorP>
      <StyledErrorP>
        If you’re still stuck, shoot us an email at <a href="mailto:support@fixel.ai">support@fixel.ai</a>
      </StyledErrorP>
      <Error404 />
    </div>
  );
};
export default ErrorPage;
